import React from 'react';

const MenuContext = React.createContext({ showMobileMenu: false });

export default MenuContext;
